/***************************************************************************

    LayoutComponent.tsx
    -------------------------
    last Update          : September 30, 2025
    by                   : quentin.savoye@cil4sys.com
    copyright            : (C) 2025 by CIL4Sys Engineering 

***************************************************************************/


/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"

import NavBarComponent from "./NavBar/NavBarComponent"
import Seo from "./SEO"
import { getPageSeo, resolvePageSeoKey, PageSeoLang } from "../lib/pageSeo"

import { WithTranslation, withTranslation } from "react-i18next"

import "../assets/css/variables.css"
import "../assets/css/root.css"

interface Props extends WithTranslation {
	children: React.ReactNode
	pageContext: { page?: string; language?: string; i18n?: Record<string, string> }
	path: string
	url: string
}

class LayoutComponent extends React.Component<Props> {
	constructor(aProps: Props) {
		super(aProps)
	}

	public override render(): React.ReactNode {
		const language = (this.props.pageContext?.language || this.props.i18n.language || "en") as PageSeoLang
		const pageLang = language === "fr" ? "fr" : "en"
		const pageKey = resolvePageSeoKey(this.props.pageContext?.page, this.props.path)
		const pageSeo = getPageSeo(pageKey, pageLang)

		return (
			<div className={"root root-" + process.env.GATSBY_STRAPI_PROJECT}>
				<style>@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');</style>
				<style>@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');</style>
				<Seo
					title={pageSeo?.title}
					description={pageSeo?.description}
					lang={pageLang}
					pageKey={pageKey}
				/>
				<NavBarComponent language={pageLang} />
				<main className="main-class">{this.props.children}</main>
				{/* Footer lives inside page templates (scroll container), not here */}
			</div>
		)
	}
}

export default withTranslation()(LayoutComponent)
